import { useHeroForm } from "../contexts/HeroFormContext";
import { onMount } from "solid-js";
import { getMeasureTypeOption } from "../js/variantsUtil";

export const FixedProductCTA = () => {

    const {
        sizeSettings: {
          sendRefData,
          measurementOptionsV2
        },
        color: {
          color
        },
        customer: {
          metafield: customerMetafield
        }
      } = useHeroForm()
      const selectedColor = () => color().options[color().selected];

      const range = (start, end, step = 1) => {
        let output = [];
        if (typeof end === 'undefined') {
          end = start;
          start = 0;
        }
        for (let i = start; i < end; i += step) {
          output.push(i);
        }
        return output;
      };
    
      const roundPrice = (price) => Math.ceil(price).toFixed(2); // parseFloat(parseFloat(price.toFixed(2)).toFixed(1)).toFixed(2);

      const price = () => {
        const measurementOptionSelected = measurementOptionsV2['selected'];
        const colorSelected = color()['selected'];
    
        const measureTypeOption = getMeasureTypeOption(measurementOptionSelected, measurementOptionsV2.options, customerMetafield, sendRefData());
    
        const { currency, currencySymbol, currencyConversionRate = 1 } = productInfo;
    
        const { price } = productInfo['variants'][measureTypeOption][colorSelected]
    
        return currencySymbol?.trim()?.length > 0 ? `${currencySymbol} ${roundPrice(price * currencyConversionRate)}` : Intl.NumberFormat("en-IN", {
          "currency": currency,
          "style": "currency",
          "maximumFractionDigits": 0
        }).format(price)
      }

      const productImage = () => color().options[selectedColor().id].galleryImages[0]?.src;

      const srcSet = ()  => range(16, 500, 16).map(width => `${productImage()}&width=${width} ${width}w `);

    //   let changeOrderBtnVisibility = (entries, observer) => {     
    //     let visibility = entries.reduce((part, a) => part + a.isIntersecting, 0)
    //     if (visibility) {            
    //         document.getElementById('up-arrow').classList.add('-translate-y-16', 'lg:-translate-x-60');
    //     } else {                            
    //         document.getElementById('up-arrow').classList.remove('-translate-y-16', 'lg:-translate-x-60');                
    //     }

    // }

    // let orderButtonVisibilityObserver = new IntersectionObserver(changeOrderBtnVisibility, {threshold:[0.01]});
                 
    // document.addEventListener('DOMContentLoaded', function() {        

    //     const productAboveFoldElement = document.getElementById('product-hero-flat');            
    //     if (productAboveFoldElement){
        
    //     orderButtonVisibilityObserver.observe(productAboveFoldElement); }

    // });

    onMount(() => {
        let changeOrderBtnVisibility = (entries) => {     
            let visibility = entries.reduce((part, a) => part + a.isIntersecting, 0)
            if (visibility) {            
                document.getElementById('up-arrow').classList.add('-translate-x-60');
            } else {                            
                document.getElementById('up-arrow').classList.remove('-translate-x-60');                
            }
    
        }
        let orderButtonVisibilityObserver = new IntersectionObserver(changeOrderBtnVisibility, {threshold:[0.01]});
        const productAboveFoldElement = document.getElementById('product-hero-flat'); 
        if (productAboveFoldElement){
            orderButtonVisibilityObserver.observe(productAboveFoldElement); 
        }
      });
    
    const { title, displayName, descriptorsSubtitle } = productInfo;

    return (
        <a href="#page-body"><div id="up-arrow" class="fixed justify-between group flex items-stretch
                                                        translate-y-0
                                                       -translate-x-60
                                                       bottom-1 right-auto left-1
                                                       border-outer 
                                                       rounded-2xl
                                                       transition-all duration-75 
                                                       bg-canvas font-mono text-ink text-sm lg:hover:bg-ink border-frame lg:hover:text-canvas z-[100] gap-1 p-1  mr-8">
        <div class="flex items-center h-full">
            <img src={`${productImage()}&width=2`} data-srcset={srcSet()} 
            width="auto"
            height="auto"
            data-sizes="auto"
            class="lazyautosizes lazyload w-6 aspect-[4/5] object-cover text-transparent rounded-lg"        
            alt={displayName != '' ? displayName : title}
            loading="lazy"
            srcset={ srcSet() }
            ></img>    
        </div>
        <div class="flex flex-col grow justify-center gap-0.5 h-full">
            <span class="font-regular text-sm font-bold">{descriptorsSubtitle}</span>
            {/* <span class="font-bold uppercase text-lg leading-none">{displayName != '' ? displayName : title}</span> */}
        <div class="flex justify-start gap-1">
            <span class="text-xs sm:text-xs font-regular">{selectedColor().label}</span>
            <span class="text-xs sm:text-xs font-mono">{price()}</span>
        </div>
        </div>
        <div class="pl-2 py-1 border-frame items-center text-ink leading-none sm:group-hover:border-canvas sm:group-hover:text-canvas  flex gap-1 text-lg">
            
            <span class="text-xs hidden font-bold uppercase">Order<br /> now</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 group-hover:-translate-y-0.5 transition-transform">
                <path fill-rule="evenodd" d="M10 15a.75.75 0 01-.75-.75V7.612L7.29 9.77a.75.75 0 01-1.08-1.04l3.25-3.5a.75.75 0 011.08 0l3.25 3.5a.75.75 0 11-1.08 1.04l-1.96-2.158v6.638A.75.75 0 0110 15z" clip-rule="evenodd" />
            </svg>
    </div>         
    </div>
    </a>
    )
  }